export default __webpack_public_path__ + "static/media/chairman-giving-speech-portrait.ceba98e6.jpeg";